import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

// TODO: update API endpoint

export default {
    async getContactDetails(clientId, params) {
        return Axios.get(
            `${baseURL}actor/actor-contact-details/${clientId}`,
            params
        ).then(response => response.data);
    },
    async addContactDetail(clientId, params) {
        return Axios.post(
            `${baseURL}actor/actor-contact-details/${clientId}`,
            params
        ).then(response => response.data);
    },
    async updateContactDetail(clientId, params) {
        return Axios.put(
            `${baseURL}actor/actor-contact-details/${clientId}`,
            params
        ).then(response => response.data);
    },
    async deleteContactDetail(clientId, params) {
        return Axios.delete(
            `${baseURL}actor/actor-contact-details/${clientId}`,
            params
        ).then(response => response.data);
    },
    async assignPrimaryContactDetail(clientId, params) {
        return Axios.put(
            `${baseURL}actor/actor-contact-details/assign-primary/${clientId}`,
            params
        ).then(response => response.data);
    },
    async getPrimaryContactDetails(clientId, params) {
        return Axios.get(
            `${baseURL}actor/actor-contact-details/get-primary/${clientId}`,
            params
        ).then(response => response.data);
    }
};
